import { ohneWetter } from "./wetterteil.js";



/* §2 ─ Persistenz & Synchronisation ───────────────────────────── */

const LOKAL_BASIS = "winelake:lokal:v1";

const lokalSchluessel = (benutzername) => `${LOKAL_BASIS}:${benutzername}`;

/* Zuletzt angemeldetes Konto. Ohne Netz kann `/api/ich` nicht
   antworten; ohne diese Kopie landete man dann auf der Anmeldemaske
   und käme an den eigenen, lokal vorhandenen Stand nicht heran. Es
   sind nur Anzeigemerkmale — keine Sitzung, kein Geheimnis. Die
   Berechtigung prüft weiterhin ausschließlich der Server, sobald er
   wieder erreichbar ist. */
const KONTO_SCHLUESSEL = "winelake:konto:v1";


/* Die lokale Kopie selbst liegt seit Oktober 2026 in IndexedDB
   (dienste/lokalkopie.js). Der Schlüssel oben bleibt für den Umzug
   alter Kopien und als Rückfall, wenn IndexedDB nicht nutzbar ist. */


function ladeKonto() {
  try {
    const roh = localStorage.getItem(KONTO_SCHLUESSEL);
    if (roh) {
      const k = JSON.parse(roh);
      if (k && k.benutzername) return k;
    }
  } catch (e) { /* privater Modus o. ä. */ }
  return null;
}


function speichereKonto(nutzer) {
  try { localStorage.setItem(KONTO_SCHLUESSEL, JSON.stringify(nutzer)); } catch (e) {}
}


function vergissKonto() {
  try { localStorage.removeItem(KONTO_SCHLUESSEL); } catch (e) {}
}


/* Fehlerobjekt mit HTTP-Status — 401 bedeutet: Sitzung abgelaufen. */
async function apiFehler(r, standard) {
  const e = new Error(standard);
  e.status = r.status;
  try {
    const j = await r.json();
    if (j && j.fehler) e.message = j.fehler;
  } catch (x) { /* Antwort ohne JSON */ }
  return e;
}


/* Server-API (siehe server.js): /api/version ist die leichte
   Update-Prüfung, /api/kellerbuch liefert bzw. schreibt den Stand. */
async function apiVersion() {
  const r = await fetch("/api/version");
  if (!r.ok) throw await apiFehler(r, "Versionsabfrage fehlgeschlagen");
  return (await r.json()).version;
}


async function apiLaden() {
  const r = await fetch("/api/kellerbuch");
  if (!r.ok) throw await apiFehler(r, "Laden fehlgeschlagen");
  return r.json(); /* { version, daten } */
}


/* Ab dieser Größe lohnt das Packen — darunter kostet es mehr, als es
   spart. Ein großer Keller schrumpft von gut 3 MB auf rund 0,25 MB. */
const PACKEN_AB = 16 * 1024;

async function packe(text) {
  if (typeof CompressionStream === "undefined" || text.length < PACKEN_AB) return null;
  try {
    const strom = new Blob([text]).stream().pipeThrough(new CompressionStream("gzip"));
    return await new Response(strom).blob();
  } catch (e) {
    return null;
  }
}

/** Schreibt den Stand. Der Wetterteil bleibt auf dem Gerät
    (kern/wetterteil.js), der Rest geht gzip-gepackt hinaus; body-parser
    entpackt auf dem Server selbst. Lehnt der Server die gepackte Form
    ab (ein Zwischenglied, das Content-Encoding nicht durchlässt), wird
    einmal ungepackt nachgelegt.

    Fehler tragen `status`; bei 413 zusätzlich `zuGross` — der Aufrufer
    zeigt dann einen Fehler statt „offline“. */
async function apiSpeichern(basisVersion, daten) {
  const text = JSON.stringify({ basisVersion, daten: ohneWetter(daten) });
  const gepackt = await packe(text);
  const senden = (body, packt) => fetch("/api/kellerbuch", {
    method: "PUT",
    headers: packt
      ? { "Content-Type": "application/json", "Content-Encoding": "gzip" }
      : { "Content-Type": "application/json" },
    body,
  });
  let r = await senden(gepackt || text, !!gepackt);
  if (gepackt && (r.status === 400 || r.status === 415)) r = await senden(text, false);
  if (r.status === 409) return { konflikt: true, ...(await r.json()) };
  if (!r.ok) {
    const e = await apiFehler(r, "Speichern fehlgeschlagen");
    if (r.status === 413) e.zuGross = true;
    throw e;
  }
  return r.json(); /* { version } */
}

export { KONTO_SCHLUESSEL, LOKAL_BASIS, apiFehler, apiLaden, apiSpeichern, apiVersion, ladeKonto, lokalSchluessel, packe, speichereKonto, vergissKonto };
